import React, { Fragment } from 'react';

import './EmployeeInfo.css';

const EmployeeInfo = (props) => {
  // Helper function to check if input is valid (backward compatible)
  const checkValid = (fieldName) => {
    return props?.checkInputValid ? props.checkInputValid(fieldName) : true;
  };

  // Helper to get field error
  const getError = (fieldName) => {
    return props?.getFieldError
      ? props.getFieldError(`employee.${fieldName}`)
      : null;
  };

  // Helper to check if should show error
  const shouldShowError = (fieldName) => {
    return props?.errMsg && getError(fieldName);
  };

  return (
    <Fragment>
      {window.location.href.indexOf('newHire') === -1 && (
        <div
          className={
            shouldShowError('employeeNumber')
              ? 'employeeNum error'
              : 'employeeNum'
          }
        >
          <label htmlFor="empNum" className="required">
            Employee Num:
          </label>
          <input
            type="number"
            id="empNum"
            name="employeeNumber"
            value={props.payload?.employee?.employeeNumber}
            required
            className="empNum"
            onChange={(e) => props.changeEmpInfo(e)}
          />
          {shouldShowError('employeeNumber') && (
            <span className="error-text">{getError('employeeNumber')}</span>
          )}
        </div>
      )}
      <div
        className={
          shouldShowError('employeeFirst')
            ? 'employeeName error'
            : 'employeeName'
        }
      >
        <label htmlFor="empFName" className="required">
          Employee First Name:
        </label>
        <input
          type="text"
          id="empFName"
          name="employeeFirst"
          value={props.payload?.employee?.employeeFirst}
          required
          className={
            checkValid('employeeFirst') ? 'empName' : 'empName input-invalid'
          }
          onChange={(e) => props.changeEmpInfo(e)}
        />
        {shouldShowError('employeeFirst') && (
          <span className="error-text">{getError('employeeFirst')}</span>
        )}
      </div>
      <div className="employeeName">
        <label htmlFor="empMName">Employee Middle Name:</label>
        <input
          type="text"
          id="empMName"
          name="employeeMiddle"
          value={props.payload?.employee?.employeeMiddle}
          className={
            checkValid('employeeMiddle') ? 'empName' : 'empName input-invalid'
          }
          onChange={(e) => props.changeEmpInfo(e)}
        />
      </div>
      <div
        className={
          shouldShowError('employeeLast')
            ? 'employeeName error'
            : 'employeeName'
        }
      >
        <label htmlFor="empLName" className="required">
          Employee Last Name:
        </label>
        <input
          type="text"
          id="empLName"
          name="employeeLast"
          value={props.payload?.employee?.employeeLast}
          required
          className={
            checkValid('employeeLast') ? 'empName' : 'empName input-invalid'
          }
          onChange={(e) => props.changeEmpInfo(e)}
        />
        {shouldShowError('employeeLast') && (
          <span className="error-text">{getError('employeeLast')}</span>
        )}
      </div>
      <div className="employeeName">
        <label htmlFor="empSLName">Employee Second Last Name:</label>
        <input
          type="text"
          id="empSLName"
          name="employeeSecondLast"
          value={props.payload?.employee?.employeeSecondLast}
          className={
            checkValid('employeeSecondLast')
              ? 'empName'
              : 'empName input-invalid'
          }
          onChange={(e) => props.changeEmpInfo(e)}
        />
      </div>
    </Fragment>
  );
};

EmployeeInfo.propTypes = {};

export default EmployeeInfo;
